import "./src/styles/global.css";
import WrapWithProvider from "./src/wrap-with-provider";
import "./src/lang";

export const wrapRootElement = WrapWithProvider;
